import React from 'react';
import { adminChefName, adminClientName } from '../../masks';

const ServicesCalendarEvent = props => {
  const { service, location } = props.event;
  const fullName = adminClientName(service.client, true)
  const chefs = service.invited_chefs
    .filter(chef => chef.status === 'accepted')
    .map(({ chef }) => adminChefName(chef));
  return (
    <div className="service-calendar__event">
      {location && <p className="service-calendar__location">{location}</p>}
      {service.name && (
        <div className="service-calendar__name">{service.name}</div>
      )}
      <div className="service-calendar__client">{fullName}</div>
      {chefs.map((chef, key) => (
        <div key={key} className="service-calendar__chef">
          {chef}
        </div>
      ))}
    </div>
  );
};

export default ServicesCalendarEvent;



// WEBPACK FOOTER //
// ./src/components/services/ServicesCalendarEvent.js